import BaseTableController from './base_table_controller';

// dp_id 186 — data_grid: { rows: [{ material_name, mass_volume, unit }] }
export default class extends BaseTableController {
  static values = { unitOptions: Array };

  searchableFields = ['unit'];

  connect() {
    const rows = this.initialDataValue?.rows;
    this.rows =
      Array.isArray(rows) && rows.length > 0
        ? rows.map((r) => ({
            material_name: r.material_name ?? '',
            mass_volume: r.mass_volume ?? null,
            unit: r.unit ?? '',
          }))
        : [this.emptyRow()];
    this.renderRows();
    this.syncHiddenField();
  }

  emptyRow() {
    return { material_name: '', mass_volume: null, unit: '' };
  }

  updateField(event) {
    const el = event.currentTarget;
    const index = parseInt(el.dataset.rowIndex, 10);
    const field = el.dataset.field;
    this.rows[index][field] =
      el.type === 'number' ? (el.value === '' ? null : parseFloat(el.value)) : el.value;
    this.syncHiddenField();
  }

  buildRow(row, index) {
    const tr = document.createElement('tr');

    tr.appendChild(this.buildStringCell(row, index, 'material_name', 'Material name'));

    const massTd = document.createElement('td');
    const massInput = document.createElement('input');
    massInput.type = 'number';
    massInput.min = '0';
    massInput.step = '0.01';
    massInput.placeholder = '0.00';
    massInput.className = 'form-control w-100';
    massInput.dataset.rowIndex = index;
    massInput.dataset.field = 'mass_volume';
    massInput.dataset.action = `input->${this.identifier}#updateField`;
    if (row.mass_volume !== null && row.mass_volume !== undefined)
      massInput.value = row.mass_volume;
    massTd.appendChild(massInput);
    tr.appendChild(massTd);

    tr.appendChild(this.buildSelectCell(row, index, 'unit', this.unitOptionsValue));
    tr.appendChild(this.buildRemoveButton(index));

    return tr;
  }
}
